import memoizeOne from 'memoize-one';

import { getSuccessfulResultOrThrow } from '@atlassian/commerce-ccp-gateway-client/error-wrappers';
import type { EntitlementDetails } from '@atlassian/commerce-ccp-gateway-client';
import { entitlementsDetails_get_byEntitlementId_v1 } from '@atlassian/commerce-ccp-gateway-client';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';
import { cfetch } from '@confluence/network';

import { CcpEntitlementIdQuery } from './graphql/CcpEntitlementIdQuery.graphql.ts';
import type { CcpEntitlementIdQuery as ccpEntitlementIdQueryRes } from './graphql/__types__/CcpEntitlementIdQuery.ts';

const memoizedEntitlementsDetails_get_byEntitlementId_v1 = memoizeOne(
	entitlementsDetails_get_byEntitlementId_v1,
	(
		[
			{
				pathParameters: { entitlementId: newEntitlementId },
			},
		],
		[
			{
				pathParameters: { entitlementId: lastEntitlementId },
			},
		],
	) => {
		return newEntitlementId === lastEntitlementId;
	},
);

export const getCurrentEntitlementDetails = async (): Promise<EntitlementDetails> => {
	// get current tenant's entitlement id
	const apolloClient = getApolloClient();
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	const entitlementIdQuery = await apolloClient.query<ccpEntitlementIdQueryRes>({
		query: CcpEntitlementIdQuery,
	});
	const entitlementId =
		entitlementIdQuery?.data?.confluence_tenantContext?.licenseStates?.confluence
			?.ccpEntitlementId || '';

	if (!entitlementId) throw new Error('empty entitlementId');

	// get the entitlement details
	const entitlementDetails = getSuccessfulResultOrThrow(
		await memoizedEntitlementsDetails_get_byEntitlementId_v1({
			fetch: cfetch,
			pathParameters: {
				entitlementId,
			},
		}),
	);

	return entitlementDetails as EntitlementDetails;
};
